import { TFeedAction, TFeedsState, FeedActionType } from "../../interfaces/store/feedStore";
import { makeStore } from "../makeStore";

const initialState: TFeedsState = {
    feeds: [],
    loading: false,
    numConnections: -1,
    maxNumConnections: 0,
}

const reducer = (state: TFeedsState, action: TFeedAction): TFeedsState => {
    switch (action.type) {
        case FeedActionType.SET_FEEDS: 
            return { ...state, feeds: action.payload, loading: false }
        case FeedActionType.SET_FEED_DATA: 
            return { 
                ...state, 
                feeds: action.payload.feeds, 
                numConnections: action.payload.numConnections ?? state.numConnections,
                maxNumConnections: action.payload.maxNumConnections ?? state.maxNumConnections,
                loading: false 
            }
        case FeedActionType.ADD_FEED: 
            return { ...state, feeds: [...state.feeds, action.payload] }
        case FeedActionType.UPDATE_FEED: 
            return { 
                ...state, 
                feeds: state.feeds.map(feed => 
                    feed._id === action.payload.id 
                        ? { ...feed, ...action.payload.updates }
                        : feed
                )
            }
        case FeedActionType.DELETE_FEED: 
            return { 
                ...state, 
                feeds: state.feeds.filter(feed => feed._id !== action.payload)
            }
        case FeedActionType.SET_LOADING:
            return { ...state, loading: action.payload }
        case FeedActionType.RESET_STORE: 
            return { ...initialState }
        default: 
            return state
    }
}

const { StoreProvider: FeedsStoreProvider, useStoreContext: useFeedsStore } = makeStore(reducer, initialState)

export { FeedsStoreProvider, useFeedsStore }
